module.exports = __webpack_public_path__ + "img/BINDI 4 LIME.96ba33d.svg";